<section *ngIf="isVisible" class="sec-container sec-aux-content">
	<div class="row user-card shadow">
		<div class="nav-bar">
			<fa-icon icon="angle-left" (click)="previousMonth()"></fa-icon>
			<div class="title">
				{{ getReportHeaderTranslated()
				}}<span *ngIf="!isLoading">
					- {{ currencySymbol }} {{ sumCompensation }}</span
				>
			</div>
			<fa-icon
				icon="angle-right"
				(click)="nextMonth()"
				[class.disabled]="isNextDisabled"
			></fa-icon>
		</div>
		<p-chart
			type="line"
			[data]="data"
			[options]="options"
			[class.hidden]="isLoading"
		>
		</p-chart>
		<div class="loading" *ngIf="isLoading">
			<freud-loader size="sm" [bgColor]="false"></freud-loader>
		</div>
	</div>
</section>
